import { render, staticRenderFns } from "./CardShippingFeesPage.vue?vue&type=template&id=3c10e4c6&scoped=true&"
import script from "./CardShippingFeesPage.vue?vue&type=script&lang=js&"
export * from "./CardShippingFeesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c10e4c6",
  null
  
)

export default component.exports